<template>
  <div id="content-wrapper">
    <b-tabs content-class="mt-3">
      <b-tab
        :active="activeTab === `#${VAI_TRO_TAB.THONG_TIN_VAI_TRO}`"
        @click="changeCurrentTab(VAI_TRO_TAB.THONG_TIN_VAI_TRO)"
        title="Thông tin vai trò"
      >
        <div class="box box-form pb-5">
          <FormVaiTro
            :form="chiTietVaiTro"
            :readonly="true"
            ref="cap-nhat-vai-tro"
            :danh-sach-app="danhSachApp"
          />
          <div class="d-flex justify-content-end">
            <base-button
              button="Cập nhật"
              @click="goToSua()"
              v-if="hasPermissionUser(PERMISSION_NAME.VAI_TRO.SUA)"
            ></base-button>
            <base-button button="Đóng" @click="boQua()"></base-button>
          </div>
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === `#${VAI_TRO_TAB.NGUOI_DUNG}`"
        @click="changeCurrentTab(VAI_TRO_TAB.NGUOI_DUNG)"
        title="Người dùng"
      >
        <div class="box box-form">
          <DanhSachNguoiDungTheoVaiTro
            :chiTietVaiTro="chiTietVaiTro"
            :key="`thuoc-vai-tro-${chiTietVaiTro.Id}`"
            :readonly="true"
            ref="danhSachNguoiDungThuocVaiTro"
          />
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === `#${VAI_TRO_TAB.QUYEN}`"
        @click="changeCurrentTab(VAI_TRO_TAB.QUYEN)"
        title="Phân quyền"
      >
        <div class="box box-form">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
            <div class="col-md-8 col-xs-12"></div>
          </div>
          <DanhSachQuyenTrongVaiTro
            :chiTietNguoiDung="chiTietVaiTro"
            :key="`danh-sach-quyen-${chiTietVaiTro.Id}`"
            :appId="internalAppId"
            :readonly="true"
            ref="danhSachQuyenTrongVaiTro"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BO_QUA_BUTTON_LABEL,
  ROUTE_NAME,
  VAI_TRO_TAB,
  PERMISSION_NAME,
} from "@/constants/constants";
import FormVaiTro from "@/components/pages/quan-tri-he-thong/vai-tro/FormVaiTro";
import DanhSachNguoiDungTheoVaiTro from "@/components/pages/quan-tri-he-thong/nguoi-dung/DanhSachNguoiDungTheoVaiTro";
import DanhSachQuyenTrongVaiTro from "@/components/pages/quan-tri-he-thong/quyen/DanhSachQuyenTrongVaiTro";
import { mapGetters } from "vuex";
import { hasPermissionUser } from "@/utils/permissionUtils";
export default {
  name: "XemVaiTro",
  data() {
    return {
      PERMISSION_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      internalChiTietVaiTro: {},
      activeTab: VAI_TRO_TAB.THONG_TIN_VAI_TRO,
      VAI_TRO_TAB: VAI_TRO_TAB,
      internalAppId: null,
    };
  },
  components: {
    FormVaiTro,
    DanhSachNguoiDungTheoVaiTro,
    DanhSachQuyenTrongVaiTro,
  },
  computed: {
    ...mapGetters({
      chiTietVaiTro: "role/chiTietVaiTro",
      danhSachApp: "app/tatCaApp",
    }),
    danhSachAppNoiBo() {
      if (
        this.danhSachApp &&
        this.chiTietVaiTro &&
        this.chiTietVaiTro.applicationIds
      ) {
        return this.danhSachApp.filter((x) =>
          this.chiTietVaiTro.applicationIds.includes(x.id)
        );
      } else {
        return [];
      }
    },
  },
  created() {
    this.activeTab = location.hash;
    this.$store.dispatch("role/layChiTietVaiTro", {
      id: this.$router.currentRoute.params.id,
    });
    this.layDanhSachApp();
  },
  watch: {
    chiTietVaiTro: {
      handler() {
        this.internalChiTietVaiTro = Object.assign(
          {},
          this.internalChiTietVaiTro,
          this.chiTietVaiTro
        );
        if (
          this.chiTietVaiTro.applicationIds &&
          this.chiTietVaiTro.applicationIds.length === 1
        ) {
          this.internalAppId = this.chiTietVaiTro.applicationIds[0];
        }
      },
    },
  },
  methods: {
    hasPermissionUser,
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    changeCurrentTab(currentTab) {
      this.$router
        .push({
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_VAI_TRO,
          hash: `#${currentTab}`,
        })
        .catch(() => {});
    },
    boQua() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO,
      });
    },
    goToSua() {
      window.location.href = `/${ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}/${this.$router.currentRoute.params.id}`;
    },
  },
};
</script>


